import EdSectionState from './ed-section-state/ed-section-state.component.vue';

export const StatesComponents = {
  EdSectionState,
}